import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';

import ComposeModalStatus from '../../../components/Compose/ComposeModal/ComposeModalStatus';

import ComposeStatus from '../../../components/MUI/Compose/Status';
import { MessageStatus } from '../../../generated/graphql';

import useComposeType from '../../../hooks/router/search/useComposeType';
import useIsMobile from '../../../hooks/useIsMobile';

import { mapDispatchToProps, mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Container for setting the status for task
 *
 * @param props                     Props passed to the container
 * @param props.dataStatusCurrent   Currently selected status
 * @param props.requestStatusChange Request setting the current status
 * @returns                         The container itself
 */
const ComposeMetaStatusContainer: FC<Props> = ({
  dataStatusCurrent,
  requestStatusChange,
}) => {
  const isMobile = useIsMobile();
  const composeType = useComposeType();

  const isTask = composeType === 'task';

  useEffect(() => {
    // We set it here, not in initializer because we need it to be set only
    // when it's used
    if (dataStatusCurrent === null && isTask) {
      requestStatusChange(MessageStatus.OPEN);
    }
    // Exclude dataStatusCurrent as we update only on initial load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTask, requestStatusChange]);

  if (dataStatusCurrent === null) {
    return null;
  }

  const Component = isMobile ? ComposeStatus : ComposeModalStatus;

  return (
    <Component
      dataStatusCurrent={dataStatusCurrent}
      requestStatusChange={requestStatusChange}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComposeMetaStatusContainer);
